import PropTypes from 'prop-types';
import React from 'react';

import {displayInboxShortDate, displayShortDate} from '../../utils/utils';
import styles from './Message.module.scss';

const Message = ({ subject, children, createdTimestamp, isIrt }) => (
  <div>
    <p className={`${styles['message-date']} branded-message-date`}>
      { isIrt ? displayInboxShortDate(createdTimestamp) :
          displayShortDate(createdTimestamp, true)}
    </p>
    <p
      className={`${styles['message-subject']} branded-message-subject`}
      dangerouslySetInnerHTML={{
        __html: subject
      }}
    ></p>
    {children}
  </div>
);

Message.propTypes = {
  children: PropTypes.node,
  createdTimestamp: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  isIrt: PropTypes.bool,
  subject: PropTypes.string,
};

export default Message;
